// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createVendorPaymentCall = (client) => ({
    /**
     * `POST /vendor/payment-call/scripts/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorApprovePaymentCallScript
     * @source apps/backend/src/api/vendor/payment-call/scripts/[id]/approve/route.ts
     */
    approveScript: (id, body, query, headers) => client.fetch(buildPath("/vendor/payment-call/scripts/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/payment-call/scripts`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreatePaymentCallScript
     * @source apps/backend/src/api/vendor/payment-call/scripts/route.ts
     */
    createScript: (body, query, headers) => client.fetch("/vendor/payment-call/scripts", { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/payment-call/settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPaymentCallSettings
     * @source apps/backend/src/api/vendor/payment-call/settings/route.ts
     */
    getSettings: (query, headers) => client.fetch("/vendor/payment-call/settings", { method: "GET", query, headers }),
    /**
     * `GET /vendor/payment-call/scripts`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorListPaymentCallScripts
     * @source apps/backend/src/api/vendor/payment-call/scripts/route.ts
     */
    listScripts: (query, headers) => client.fetch("/vendor/payment-call/scripts", { method: "GET", query, headers }),
    /**
     * `POST /vendor/payment-call/script-preview`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorCreatePaymentCallScriptPreview
     * @source apps/backend/src/api/vendor/payment-call/script-preview/route.ts
     */
    previewScript: (body, query, headers) => client.fetch("/vendor/payment-call/script-preview", { method: "POST", body, query, headers }),
    /**
     * `POST /vendor/payment-call/scripts/:id/reject`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorRejectPaymentCallScript
     * @source apps/backend/src/api/vendor/payment-call/scripts/[id]/reject/route.ts
     */
    rejectScript: (id, body, query, headers) => client.fetch(buildPath("/vendor/payment-call/scripts/:id/reject", [id]), { method: "POST", body, query, headers }),
    /**
     * `GET /vendor/payment-call/scripts/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorGetPaymentCallScript
     * @source apps/backend/src/api/vendor/payment-call/scripts/[id]/route.ts
     */
    retrieveScript: (id, query, headers) => client.fetch(buildPath("/vendor/payment-call/scripts/:id", [id]), { method: "GET", query, headers }),
    /**
     * `POST /vendor/payment-call/scripts/:id/submit`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorSubmitPaymentCallScript
     * @source apps/backend/src/api/vendor/payment-call/scripts/[id]/submit/route.ts
     */
    submitScript: (id, body, query, headers) => client.fetch(buildPath("/vendor/payment-call/scripts/:id/submit", [id]), { method: "POST", body, query, headers }),
    /**
     * `PUT /vendor/payment-call/scripts/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdatePaymentCallScript
     * @source apps/backend/src/api/vendor/payment-call/scripts/[id]/route.ts
     */
    updateScript: (id, body, query, headers) => client.fetch(buildPath("/vendor/payment-call/scripts/:id", [id]), { method: "PUT", body, query, headers }),
    /**
     * `PUT /vendor/payment-call/settings`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId VendorUpdatePaymentCallSettings
     * @source apps/backend/src/api/vendor/payment-call/settings/route.ts
     */
    updateSettings: (body, query, headers) => client.fetch("/vendor/payment-call/settings", { method: "PUT", body, query, headers }),
});
//# sourceMappingURL=payment-call.js.map